import script from "./WorkflowGraph.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkflowGraph.vue?vue&type=script&setup=true&lang=js"

import "./WorkflowGraph.vue?vue&type=style&index=0&id=1533f2cc&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1533f2cc"]])

export default __exports__